<template>
  <div class="progress-box">
    <img :src="src" width="100%" v-if="show" />
  </div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
export default {
  name: "Index",
  props: ["ProgressgVisible"],
  data() {
    return {
      show: false,
      src: require("../assets/images/20200927144025.gif"),
      number: "1",
    };
  },
  mounted() {
    this.show = true;
    var number = Math.random(1, 2);
    console.log(number);
    this.src =
      "https://yizhibao-app.oss-cn-beijing.aliyuncs.com/image/aaa04.gif?n=" +
      number;
  },
  methods: {
    // 设置定时器
    setDateTimeInterval() {
      console.log("888");
    },
  },
  computed: {},
  watch: {
    //监听value的变化，进行相应的操作即可
    dialogVisible: function (a, b) {
      alert("66");
      console.log(this.show,"dadas");
    },
  },
};
</script>
<style >
html {
  line-height: 1.15; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
  height: 100%;
}

[hidden] {
  display: none;
}
.progress-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  z-index: -10;
}
</style>
